import React from "react";
import {
  Mail,
  Phone,
  MapPin,
  Download,
  ArrowUpRight,
  Sparkles,
  Github,
  Linkedin,
  MessageCircle,
} from "lucide-react";
import { PROFILE } from "../data/profile";
import Nav from "../components/portfolio/Nav";
import Hero from "../components/portfolio/Hero";
import About from "../components/portfolio/About";
import Skills from "../components/portfolio/Skills";
import Projects from "../components/portfolio/Projects";
import Certifications from "../components/portfolio/Certifications";
import AISection from "../components/portfolio/AISection";
import Contact from "../components/portfolio/Contact";
import Footer from "../components/portfolio/Footer";

export default function Portfolio() {
  return (
    <main data-testid="portfolio-root" className="relative isolate min-h-screen">
      <Nav />
      <Hero />
      <About />
      <Skills />
      <AISection />
      <Projects />
      <Certifications />
      <Contact />
      <Footer />
    </main>
  );
}
